export const environment = {
  production: false,
  staging: true,
  baseServerUrl: "https://api2.azuremania.net",
  authClientId: "716774908644-gb97erp187ndioi2irc03d0tgbm2ijb0.apps.googleusercontent.com",
  initialCostBucketName: "eks-json-storage",
  initialCostPathName: "initial-cost-json"
};
